import { Footnote, Group, Icon, TIconNames, createStyles } from '@ingeniorforeningen/figurine-core';
import { useIsColumn } from '../../hooks';
import './PrintStyling.css';

type Props = {
  text: string;
  iconName: TIconNames;
  date?: string;
  cypress?: string;
};

const styles = createStyles((theme) => ({
  seperator: {
    width: '0.2rem',
    height: '0.19rem',
    backgroundColor: theme.black,
    borderRadius: '0.2rem',
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
  },
}));

const InfoMessage = ({ text, iconName, date, cypress }: Props) => {
  const { classes } = styles();
  const { isColumn } = useIsColumn();

  return (
    <Group
      direction="column"
      align="center"
      py="md"
      mx="xl"
      cypress={cypress ?? 'infoMessage'}
      className="hidden-in-print"
    >
      <Icon name={iconName} size="sm" cypress="icon" />
      <Group align="center" spacing={0} direction={isColumn ? 'column' : 'row'}>
        <Footnote text={text} align="center" cypress="text" />
        {date && (
          <Group spacing={0} align="center" direction="row">
            <div className={classes.seperator} />
            <Footnote text={date} cypress="date" />
          </Group>
        )}
      </Group>
    </Group>
  );
};

export default InfoMessage;
